// src/pages/Routing.jsx
import React from "react";
import { Navigate } from "react-router-dom";

export default function Routing() {
  return <Navigate to="/routing/routing-x-pos" replace />;
}
